'use client';

import { useState } from 'react';
import AnimateOnScroll from '@/components/AnimateOnScroll';
import GridSection from '@/components/site/GridSection';
import { PRICING_FAQS } from './data';

/**
 * Pricing-specific FAQ. Same accordion mechanics as the homepage FaqSection,
 * restyled as white cards for the grid-paper page (Inter, no warm band).
 * GridClearing re-snaps on expand/collapse via its ResizeObserver.
 */
export default function PricingFaqSection() {
  const [open, setOpen] = useState<Set<number>>(new Set([0]));

  const toggle = (i: number) =>
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(i)) next.delete(i);
      else next.add(i);
      return next;
    });

  return (
    <GridSection id="faq">
      <AnimateOnScroll animation="fade-up">
        <div data-grid-block className="mx-auto max-w-[780px] text-center">
          <span className="block font-jetbrains text-[11px] font-semibold tracking-[0.16em] text-brand-600">
            PRICING FAQ
          </span>
          <h2 className="mt-4 font-onest text-[clamp(28px,3.2vw,36px)] font-extrabold tracking-[-0.02em] text-ink">
            Billing questions, answered.
          </h2>
        </div>
      </AnimateOnScroll>

      <AnimateOnScroll animation="fade-up">
        {/* ONE grid block for the whole list → one clean whole-cell clearing. */}
        <div data-grid-block className="mx-auto max-w-[780px] space-y-3">
          {PRICING_FAQS.map((item, i) => {
            const isOpen = open.has(i);
            return (
              <div key={item.q} className="rounded-ref border border-line bg-surface px-6 shadow-ref">
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 py-[18px] text-left text-[16px] font-semibold text-ink"
                >
                  {item.q}
                  <span
                    className={`grid h-[26px] w-[26px] shrink-0 place-items-center rounded-lg border transition-[transform,background-color,border-color,color] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${
                      isOpen
                        ? 'rotate-180 border-transparent bg-brand-600 text-white'
                        : 'border-line-2 text-muted'
                    }`}
                  >
                    ▾
                  </span>
                </button>
                <div
                  className={`grid overflow-hidden transition-[grid-template-rows,opacity] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="min-h-0">
                    <p className="mb-[18px] text-[15px] leading-[1.65] text-muted">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </AnimateOnScroll>
    </GridSection>
  );
}
